import { EPermissoes } from '@/enums/ePermissoes';
export default [
  {
    description: 'Projetista',
    path: '/gestao/Projetista',
    name: 'proprojetista',
    component: () => import('@/views/projeto/proprojetista/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Projetista',
    parent: 'proprojetista',
    path: '/gestao/Projetista/incluir',
    name: 'proprojetista-insert',
    component: () => import('@/views/projeto/proprojetista/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'proprojetista',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Projetista',
    parent: 'proprojetista',
    path: '/gestao/Projetista/editar/:id',
    name: 'proprojetista-update',
    component: () => import('@/views/projeto/proprojetista/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'proprojetista',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  }
];
